import Actions from '../state/Dashboard.actions';

export const updateSelectedDomain = domain => dispatch =>
    dispatch(Actions.updateSelectedDomain(domain));

export const updateTodoPreferences = preferences => dispatch =>
    dispatch(Actions.updateTodoPreferences(preferences));
